"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceIndexItemAbstract = exports.ServiceItemType = exports.ServiceItemGroup = void 0;
const base_1 = require("../base");
var ServiceItemGroup;
(function (ServiceItemGroup) {
    ServiceItemGroup[ServiceItemGroup["Default"] = 0] = "Default";
    ServiceItemGroup[ServiceItemGroup["Faqpage"] = 1] = "Faqpage";
})(ServiceItemGroup || (exports.ServiceItemGroup = ServiceItemGroup = {}));
var ServiceItemType;
(function (ServiceItemType) {
    ServiceItemType["ServicePage"] = "servicepage";
    ServiceItemType["FaqPage"] = "faqpage";
})(ServiceItemType || (exports.ServiceItemType = ServiceItemType = {}));
class ServiceIndexItemAbstract extends base_1.BaseIndexItemAbstract {
    constructor() {
        super(...arguments);
        this.type = ServiceItemType.ServicePage;
        this.internalGroup = ServiceItemGroup.Default;
    }
}
exports.ServiceIndexItemAbstract = ServiceIndexItemAbstract;
